import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { I18nProvider } from "@/i18n";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { SmoothScroll, ScrollManager } from "@/components/layout/SmoothScroll";
import { CookieConsent } from "@/components/layout/CookieConsent";
import Home from "@/pages/Home";
import Order from "@/pages/Order";
import DocsIndex from "@/pages/DocsIndex";
import DocPage from "@/pages/DocPage";
import Faq from "@/pages/Faq";
import Legal from "@/pages/Legal";
import PaymentResult from "@/pages/PaymentResult";
import Contact from "@/pages/Contact";
import Resellers from "@/pages/Resellers";
import { WhatsAppButton } from "@/components/layout/WhatsAppButton";
import CatalogIndex from "@/pages/CatalogIndex";
import CategoryPage from "@/pages/CategoryPage";
import ProductPage from "@/pages/ProductPage";
import Packs from "@/pages/Packs";
import Deals from "@/pages/Deals";
import AdminPage from "@/pages/admin/AdminPage";

function AppShell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return <>
        {!isAdmin && <SmoothScroll />}
        {!isAdmin && <ScrollManager />}
        {!isAdmin && <Header />}
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/commander" element={<Order />} />
            <Route path="/documentation" element={<DocsIndex />} />
            <Route path="/documentation/:slug" element={<DocPage />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/revendeurs" element={<Resellers />} />
            <Route path="/equipements" element={<CatalogIndex />} />
            <Route path="/equipements/:slug" element={<CategoryPage />} />
            <Route path="/equipements/:category/:product" element={<ProductPage />} />
            <Route path="/packs" element={<Packs />} />
            <Route path="/bonnes-affaires" element={<Deals />} />
            <Route path="/admin/*" element={<AdminPage />} />
            <Route path="/cgv" element={<Legal k="cgv" />} />
            <Route path="/mentions-legales" element={<Legal k="mentions" />} />
            <Route path="/confidentialite" element={<Legal k="privacy" />} />
            <Route path="/cookies" element={<Legal k="cookiesPolicy" />} />
            <Route path="/paiement/succes" element={<PaymentResult />} />
            <Route path="/paiement/annule" element={<PaymentResult cancelled />} />
            <Route path="/paiement/mollie" element={<PaymentResult provider="mollie" />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        {!isAdmin && <Footer />}
        {!isAdmin && <CookieConsent />}
        {!isAdmin && <WhatsAppButton />}
      </>;
}

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
